module.exports = __webpack_public_path__ + "e6d455c2f1f69ca73d18d9007d09265c.MP3";